export default [
  // 加减收测算（菜单入口进入）
  {
    path: "/order-price-forecast",
    name: "orderPriceForecast",
    component: () => import("./index.vue"),
  },
  // 加减收测算（mtds订单详情-价费明细进入）
  // 订单查询按钮屏蔽、添加标准品按钮屏蔽、删除按钮屏蔽、标准品数量只能查看不能修改、收货地址只能查看不可修改
  {
    path: "/order-price-forecast-see/:formInput",
    name: "orderPriceForecastSee",
    component: () => import("./index.vue"),
    // props: true,
    meta: {
      // 根据按钮的页面权限
      permissionsButton: [
        // 零售订单详情-费用明细按钮（使用结算价预算按钮权限）
        { permission: "LSDPreSettlementPriceBtn" },
      ],
      permissionsUserType: ["oppein"],
    },
  },
  // 加减收测算（group订单详情-加减收测算进入）
  // 订单查询按钮屏蔽
  {
    path: "/order-price-forecast-search/:formInput",
    name: "orderPriceForecastSearch",
    component: () => import("./index.vue"),
    // props: true,
    meta: {
      // 根据用户类型限定权限，根据reqGetCurrentUser返回的user.departments判断,oppein为集团用户，shop为商场用户
      permissionsUserType: ["oppein"],
    },
  },
];



// WEBPACK FOOTER //
// ./src/page/order-price-forecast/routes.js